import { ECartType, EItemGroup, IEcommerceService } from '@services/ecommerceService';
import { getPriceWithoutVat } from '@utils/math';

import { ICartServiceInfo, ICustomService } from '../../model';

export const createEcommerceService = (service: ICartServiceInfo): IEcommerceService => ({
  productCode: service.productCode ? service.productCode.toUpperCase() : '',
  productName: service.productCode,
  vat: service.vat,
  price: getPriceWithoutVat(service.priceSumWithVat, service.vat),
  fullPrice: service.priceSumWithVat,
  quantity: service.count,
  group: EItemGroup.SERVICE,
  cartType: ECartType.Cart,
});

export const createEcommerceCustomService = (service: ICustomService, vat: number): IEcommerceService => ({
  productCode: 'ENGRAVING',
  productName: 'ENGRAVING',
  vat: vat,
  price: getPriceWithoutVat(service.priceWithVat, vat),
  fullPrice: service.priceWithVat,
  quantity: 1,
  group: EItemGroup.SERVICE,
  cartType: ECartType.Cart,
});
